/**
 * ModulePlaceableAnimState enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ModulePlaceableAnimState.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum ModulePlaceableAnimState {
  DEFAULT     = 10000, //304 - 
  DAMAGE      = 10014, //305 - damage
  DEAD        = 10072, //307 - 
  ACTIVATE    = 10073, //308 - NWSCRIPT Constant = 200
  DEACTIVATE  = 10074, //309 - NWSCRIPT Constant = 201
  OPEN        = 10075, //310 - NWSCRIPT Constant = 202
  CLOSE       = 10076, //311 - NWSCRIPT Constant = 203
  CLOSE_OPEN  = 10077, //312 - 10077 is a guess
  OPEN_CLOSE  = 10078, //313 - 10078 is a guess
  ANIMLOOP01  = 10106, //316 - NWSCRIPT Constant = 204
  ANIMLOOP02  = 10107, //317 - NWSCRIPT Constant = 205
  ANIMLOOP03  = 10108, //318 - NWSCRIPT Constant = 206
  ANIMLOOP04  = 10110, //319 - NWSCRIPT Constant = 207
  ANIMLOOP05  = 10111, //320 - NWSCRIPT Constant = 208
  ANIMLOOP06  = 10112, //321 - NWSCRIPT Constant = 209
  ANIMLOOP07  = 10113, //322 - NWSCRIPT Constant = 210
  ANIMLOOP08  = 10114, //323 - NWSCRIPT Constant = 211
  ANIMLOOP09  = 10115, //324 - NWSCRIPT Constant = 212
  ANIMLOOP10  = 10116, //325 - NWSCRIPT Constant = 213 
}